import { render } from "./ShowImg.vue?vue&type=template&id=bc093d04&scoped=true"
import script from "./ShowImg.vue?vue&type=script&lang=js"
export * from "./ShowImg.vue?vue&type=script&lang=js"

import "./ShowImg.vue?vue&type=style&index=0&id=bc093d04&scoped=true&lang=css"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc093d04"]])

export default __exports__